export enum CustomerType {
  Customer = 'customer',
  Lead = 'lead'
}
